import styled, { css } from 'styled-components'

import { PriceWrapper } from '@/components/Price/Price.styles'
import { Reset } from '@/lib/mixins'

export const TicketCardHeader = styled.div`
  flex: 1 1 auto;
  padding-right: 1rem;

  h4 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 0.25rem;
  }

  p {
    margin-bottom: 0;
    color: ${props => props.theme.color.muted};
  }
`

export const TicketCardOldPrice = styled.p`
  font-size: 0.7rem;
  color: ${props => props.theme.color.muted};
  margin-bottom: 0;
`

export const TicketUnlockBtn = styled.button`
  ${Reset('button')}
  background-color: ${props => props.theme.color.primaryLight};
  height: 2.75rem;
  padding: 0 1rem;
  font-weight: 600;
  min-width: 8.75rem;
`

export const TicketCardPrice = styled.div`
  text-align: right;
  margin-right: 1.25rem;

  ${PriceWrapper} {
    font-size: 1.4rem;
    font-weight: 600;
  }
`

export const TicketCardQty = styled.div``

export const TicketCardWrapper = styled.div<{ vertical?: boolean; size?: 'sm' | 'md' }>`
  display: flex;
  align-items: center;
  min-height: 11.5rem;
  border: 1px solid ${props => props.theme.color.line};
  padding: 2rem;
  &:not(:last-child) {
    margin-bottom: 1rem;
  }

  ${props =>
    props.vertical &&
    css`
      flex-direction: column;
      align-items: stretch;
      min-height: 14rem;

      &:not(:last-child) {
        margin-bottom: 0;
      }

      ${TicketCardPrice} {
        text-align: left;
      }

      ${TicketCardQty} {
        margin-left: 0;
        margin-top: 1.25rem;
      }
    `};
`
